import React , { useEffect } from "react";
import { Table } from "react-bootstrap";
import { useLang } from "../utils/LangContext";
import localStorageHelper from "../utils/localStorageHelper";

const LeaderBoardTable = ({ leaderboard }) => {
    const { t } = useLang();

    useEffect(() => {
    if (leaderboard.length > 0) {
      localStorageHelper.removeItem("game");
      localStorageHelper.removeItem("team");
    }
  }, [leaderboard]);

    return (
        <>
            <Table striped bordered hover responsive>
                <thead>
                <tr>
                    <th>#</th>
                    <th>{t("team")}</th>
                    <th>{t("points")}</th>
                </tr>
                </thead>
                <tbody>
                {leaderboard.map((item, index) => (
                    <tr
                        key={index}
                    >
                        <td>{index + 1}</td>
                        <td>{item.team_name + (
                            item.team_code === localStorageHelper.getItem("team")?.team_code
                                ? ' [' + t("myTeam") + ']'
                                : "")
                        }</td>
                        <td>{item.points}</td>
                    </tr>
                ))}
                </tbody>
            </Table>
        </>
    );
};

export default LeaderBoardTable;
